<template>
  <div>
    <mds-page-shell :logo="getProductLogo()" :logo-responsive="getProductLogo()" logo-href="/"
      logo-alt="Back to home page">
      <div class="autorenew-registration-main">
        <div class="autorenew-registration-form">
          <div class="autorenew-registration-form-container">
            <div class="title-for-autorenew-registration-form">
              <h1 class="autorenew-page-title">
                Automatic renewal of Investor Newsletter subscription
              </h1>
            </div>
            <div class="auto-renew-div">
              <p class="auto-renew-text">
                The initial term of your Newsletter subscription will begin
                immediately upon Morningstar accepting your registration, and
                your credit card will be charged for the subscription fee
                associated with the term length you selected when you
                registered. If you subscribed to the Investor Newsletters using a
                special or introductory offer, your subscription will automatically
                renew for the term length specified in that offer, and your credit
                card will be charged the subscription fee in effect at that time for
                that subscription term length. <br /><br />To stop recurring charges, you must cancel before the date on
                which your subscription period is set to renew. Otherwise, it will
                automatically renew for the same period, and your credit card will
                be charged the subscription rate applicable at that time. You can
                cancel your subscription by going to the My Account portion of
                the Investor Newsletter Service (located
                at newsletters.morningstar.com/common/account) navigating to
                “Subscription,” clicking on “Cancel Subscription” and then
                following the on-screen instructions to complete the cancellation
                process. Upon cancellation, any remaining prepaid charges will be 
                refunded to your credit card.
              </p>
            </div>

            <div class="autorenew-page-border"></div>
            <div class="by-signing-div">
              <mds-checkbox size="small" value="accept" v-model="autoRenewalChecked">I have read and agree to the
                Automatic Renewal language (set out
                above and separately included in the
                <router-link class="terms-of-use-link" target="_blank" :to="{ name: 'user-agreement' }">Terms of
                  Use</router-link>) that governs
                the automatic renewal of the Investor Newsletter Subscription(s).
              </mds-checkbox>
            </div>

      <div class="autorenew-registration-button-container">
        <div>
          <mds-button-container>
            <!-- Icon On Left -->
            <mds-button
              variation="secondary"
              size="large"
              @click="
                  $router.push({
                    name: 'billingaddress',
                    params: { productcode: $route.params.productcode },
                    query: { offerCode: $route.query.offerCode }
                  })
                "
            >
              Back
            </mds-button>
            <div class="autorenew-cancel-button">
            <mds-button
            variation="secondary"
            size="large"
            type="button"
            @click="
                $router.push({
                  name: 'combined-home',
                  params: { currentproduct: 'Common' },
                }) "
          >
            Cancel
          </mds-button>
          </div>
          <div class="autorenew-continue-button">
          <mds-button
              variation="primary"
              size="large"
              type="button"
              right-aligned
              :disabled="!autoRenewalChecked"
              @click="ContinueForm"
              >Continue
            </mds-button>
          </div>
          </mds-button-container>
        </div>
      </div>
      <div class="autorenew-register-page-bottom"></div>
    </div>
    </div>
  </div>
  </mds-page-shell>
  </div>
</template>

<script>
import { postData } from "@/utilities/API/apiUtility";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import MdsCheckbox from "@mds/checkbox";
import MdsPageShell from '@mds/page-shell';
import EncryptDecryptMixin from "../../mixins/EncryptDecryptMixin";
import { GetSessionData } from "@/utilities/userDataUtility";
export default {
  name: "autorenew-section",
  mixins: [EncryptDecryptMixin],
  components: {
    MdsCheckbox,
    MdsButton,
    MdsButtonContainer,
    MdsPageShell
  },
  data() {
    return {
      autoRenewalChecked: false,
      productCode: this.$route.params.productcode,
      userConsents: [],
      userId: "",
      MDIProductSubscription: null,
      MSIProductSubscription: null,
      MEIProductSubscription: null,
      MFIProductSubscription: null,
      subscriptionterm: ''
    };
  },

  async mounted() {
    window.scrollTo(0, 0);
    this.$store.state.layout.isHeaderRequired = false;
    this.$store.state.layout.isFooterRequired = false;
    await this.getDataFromLocalStorage();
    if (this.$store.state.user.LoggedIn) {
      this.userId = this.$auth0.user["https://morningstar.com/mstar_id"];
    } else {
      //var data = GetSessionData(this.$session).emailAddress; // Get userdetails email from localstorage
      // (data) {
        //data = JSON.parse(data);
        const sessionData = await GetSessionData(this.$session);
        var guId = sessionData.UIMId;        
        if (guId) {
          this.userId = guId;
        }
      //}
    }

  },
  methods: {
    getProductLogo() {
      var images = require.context(
        "../../../assets/Images",
        false,
        /\.svg$/
      );
      return images("./Common.svg");
    },
    async AddUserAgreements(UserId) {
      this.isLoading = true;
      var AddUserAgreementsUrl = process.env.VUE_APP_BackEndAPI + process.env.VUE_APP_AddUserAgreements;

      try {
        if (this.autoRenewalChecked) {
          this.userConsents = {};  // Initialize as an object, not an array
          this.userConsents.user = UserId;
          this.userConsents.Ids = [];  // Initialize Ids as an empty array
          const now = new Date();
          const formattedDateTime = `autorenewal_${now.getFullYear().toString().slice(2)}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getDate()).padStart(2, '0')}_T${String(now.getHours()).padStart(2, '0')}${String(now.getMinutes()).padStart(2, '0')}${String(now.getSeconds()).padStart(2, '0')}`;
          this.userConsents.Ids.push(formattedDateTime);

          const postResponse = await postData(AddUserAgreementsUrl, this.userConsents);

          if (!postResponse || postResponse.status !== 200) {
            if (process.env.NODE_ENV == 'development') {
              console.log("Error updating agreements");
            }

          }
        }

      }
      catch (error) {
        if (process.env.NODE_ENV == 'development') {
          console.log("Error in AddUserAggreements:", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    async ContinueForm() {
      if (this.MFIProductSubscription && this.MFIProductSubscription.subscriptionterm) {
        this.subscriptionterm = this.MFIProductSubscription.subscriptionterm;
        this.$gtag.event('auto_renewal', {
          'product': "MFI",
          'term': this.subscriptionterm,
          'user_id': this.userId,

        })
      } if (this.MSIProductSubscription && this.MSIProductSubscription.subscriptionterm) {
        this.subscriptionterm = this.MSIProductSubscription.subscriptionterm;
        this.$gtag.event('auto_renewal', {
          'product': "MSI",
          'term': this.subscriptionterm,
          'user_id': this.userId,
        })
      } if (this.MDIProductSubscription && this.MDIProductSubscription.subscriptionterm) {
        this.subscriptionterm = this.MDIProductSubscription.subscriptionterm;
        this.$gtag.event('auto_renewal', {
          'product': "MDI",
          'term': this.subscriptionterm,
          'user_id': this.userId,
        })
      } if (this.MEIProductSubscription && this.MEIProductSubscription.subscriptionterm) {
        this.subscriptionterm = this.MEIProductSubscription.subscriptionterm;
        this.$gtag.event('auto_renewal', {
          'product': "MEI",
          'term': this.subscriptionterm,
          'user_id': this.userId,
        })
      } if (this.currentProduct == "Common") {
        this.$gtag.event('auto_renewal', {
          'product': "Common",
          'term': this.subscriptionterm,
          'user_id': this.userId,
        })
      }
      await this.AddUserAgreements(this.userId);
      this.$router.push({
        name: "reviewsubscription",
        params: { productcode: this.productCode },
        query: { offerCode: this.$route.query.offerCode }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          console.log(err);
        }
      });
    },
    async getDataFromLocalStorage() {
      this.MEIsubscrptionData = this.getSubscriptionData("MEIProductSubscription");
      this.MSIsubscrptionData = this.getSubscriptionData("MSIProductSubscription");
      this.MDIsubscrptionData = this.getSubscriptionData("MDIProductSubscription");
      this.MFIsubscrptionData = this.getSubscriptionData("MFIProductSubscription");
    },
    getSubscriptionData(key) {
      const encryptedData = localStorage.getItem(key);
      if (!encryptedData) return;

      const decryptedData = this.Decrypt(encryptedData);
      if (!decryptedData) return;

      return decryptedData ? JSON.parse(decryptedData) : null;
    }
  
}
  }

</script>

<style scoped>
.autorenew-continue-button {
  margin-left: 10px;
  order: 2;
  width: 122px;
}

.autorenew-cancel-button {
  margin-left: auto;
}

.autorenew-register-page-bottom {
  background: linear-gradient(360deg,
      #ffffff 12.47%,
      rgba(255, 255, 255, 0) 112.75%);
  opacity: 1;
  z-index: 2;
  transform: rotate(180deg);
  height: 50px;
}

.autorenew-registration-main {
  height: 100%;
  min-height: 100vh;
  background: #f2f2f2;
}

.autorenew-registration-form {
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  background-color: #fff;
  height: 100%;
  min-height: 100vh;
}

.autorenew-page-title {
  margin-top: 0px;
  margin-bottom: 0px;
  height: 78px;
  padding-top: 57px;
  font-weight: 250;
  font-size: 28px;
  line-height: 34px;
}

.title-for-autorenew-registration-form {
  width: 100%;
}

.autorenew-page-border {
  width: 100%;
  border-bottom: 1px solid #cccccc;
}

.by-signing-text {
  margin-top: 8px;
  font-weight: 300;
  font-size: 14.7776px;
  line-height: 19px;
  color: #5e5e5e;
}

.by-signing-div {
  width: 100%;
  margin-top: 2%;
}

.auto-renew-div {
  width: 100%;
  margin-top: 5%;
  margin-bottom: 9%;
}

.auto-renew-text {
  font-weight: 300;
  font-size: 16px;
  line-height: 21px;
  color: #000000;
  margin-top: 20%;
}

.autorenew-registration-button-container {
  margin-top: 10%;
  height: 48px;
}

.terms-of-use-link {
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #1e1e1e;
}

.autorenew-registration-form-container {
  width: 380px;
  margin: 0 auto;
}

@media only screen and (max-width: 480px) {
  .autorenew-registration-form-container {
    width: 90%;
    margin: 0 auto;
  }

  .autorenew-page-title {
    padding-top: 28px;
    margin-bottom: 15%;
  }

  .auto-renew-text {
    margin-top: 10%;
  }
}
</style>
<style>
.by-signing-div .mds-checkbox__visible-wrap {
  box-shadow: none !important;
}
</style>
